<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ttZhuD/tc-custom/9781613733127.jpg?1740287945355" alt="This image is the cover for the book Death in Albert Park, Tales of the PanCosmos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death in Albert Park, Tales of the PanCosmos
      </h1>
      <p class="bookDescription body article font2">
        <p>In a gloomy London suburb, a modern Jack the Ripper stalks at night, killing at random with brutal knife thrusts from behind. Three women fall victim, and the terrorized residents wait to see who will be next.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leo Bruce
      </h2>
      
      <p class="authorDescription body article">Leo Bruce was the pen name of Rupert Croft-Cooke, who wrote more than twenty highly-praised mysteries featuring Carlous Deene. He also wrote eight mysteries featuring Sgt. William Beef, a cockney police detective who invariably "knows who done it." Croft-Cooke died in 1980.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ba5a61e